var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"banner",attrs:{"cols":"12"}},[_c('div',{staticClass:"banner-text",attrs:{"role":"banner"}},[_c('h1',[_vm._v(_vm._s(_vm.bannerHeadLine))]),_c('h2',[_vm._v(" Computational Science Studies Lab "),_c('br'),_vm._v(" Chair of Theory of Science and Technology "),_c('br'),_vm._v(" RWTH Aachen University ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }